import { FunctionComponent as F } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import { LISTINGS, PRODUCTS } from "../../../core/router/paths";
import { Product } from "@protoplan/types";
import TextTooltip from "../Tooltip/TextTooltip";


export interface SwapVendorProps
{
  product: {
    dosingId: number,
    productId: number,
    listingId?: number,
    deliverableListingsForUser: boolean } & Product;
}

const SwapVendor: F<SwapVendorProps> = props =>
{
  const navigate = useNavigate();

  const product = props.product;

  const handleSwapVendor = () =>
  {
    navigate(
      PRODUCTS + "/" + product.productId + "/" + LISTINGS,
      { state: { swapDosingId: product.dosingId, backButton: false } });
  };

  return (
    <TextTooltip lines={[(props.product.listingId ? "Swap" : "Choose") + " vendor"]}>
      <IconButton size='small' onClick={handleSwapVendor}>
        <ShoppingCartCheckoutIcon style={{ fontSize: 16, cursor: 'pointer', color: 'gray' }}/>
      </IconButton>
    </TextTooltip>);
};


export default SwapVendor;
